<rfc-title-widget [titleWidget]="headingName"></rfc-title-widget>

<rfc-description-widget
  *ngIf="description"
  [description]="description"
></rfc-description-widget>
